import clsx from 'clsx';
import React from 'react';

interface Props {
  isSelected?: boolean;
  children?: React.ReactNode;
}

const SubmissionThumbnailContainer = React.memo((props: Props) => {
  const { isSelected, children } = props;

  return (
    <div
      className={clsx(
        'group relative h-full w-full overflow-hidden border-4 border-solid bg-grey8',
        isSelected ? 'border-brightBlue' : 'border-white'
      )}
    >
      {children}
    </div>
  );
});

export default SubmissionThumbnailContainer;
